import React, { useEffect, useRef, useState } from "react";
import { Grid, TextField, Tooltip } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";

import {
  GetNomineeDetailsAPICall,
  GetNomineeModificationRequestAPICall,
  GetProfileDetailsNomineeAPICall,
  NomineeStageDetailsAPICall,
} from "../NomineeUpdateAPICalls";
import BankStyles from "./Profile.module.scss";
import SnackBar from "../../../Components/SnackBars/SnackBar";
import ErrorSnackBar from "../../../Components/SnackBars/ErrorSnackBar";
import SucessSnackBar from "../../../Components/SnackBars/SucesssnackBar";
import keyboardicon from "../../../Components/assets/Images/panicongrey.svg";
import {
  GetProfileDetailsCommonAPICall,
  SaveIpAddressAPICall,
} from "../../../shared/APICalls";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
const successModalStyles = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  width: "100%",
  height: "100vh",
  transform: "translate(-50%, -50%)",
  margin: "auto",
  borderRadius: "10px",
  boxShadow: 24,
  padding: "40px 30px",
  outline: "none",
  display: "flex",
};

export default function NomineeUpdateProfileDetails() {
  const navigate = useNavigate();

  const [loading, setloading] = useState(false);
  const [successMessage, setsuccessMessage] = useState("");
  const [userData, setUserData] = useState<any>();
  const [errorMessage, seterrorMessage] = useState("");
  const [rejectMessage, setrejectMessage] = useState("");
  const [nextStage, setNextStage] = useState("");
  const latitude:any = sessionStorage.getItem("latitude")
  const longitude:any = sessionStorage.getItem("longitude")

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);

    GetProfileDetails();
    StageDetails();
  }, []);

  const GetProfileDetails = () => {
    GetProfileDetailsCommonAPICall()
      .then((response: any) => {
        // console.log("GetProfileDetails", response.data.data.data);
        if (response.data?.data) {
          setUserData(response.data.data);
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
      });
  };

  const StageDetails = () => {
    let obj: any = {
      request_id: "",
      stage_name: "nominee_details",
    };
    setloading(true);

    NomineeStageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        //   console.log("responseDataStage", responseData.data);
        if (response.data.data.error_msg) {
          setrejectMessage(response.data.data.error_msg);
        }
        if (response.data.data.next_stage) {
          setNextStage(response.data.data.next_stage);
        }
        sessionStorage.setItem(
          "nomineeRequestID",
          response.data.data.request_id
        );
        setloading(false);
      })
      .catch((error: any) => {
        setloading(false);
      });
  };

  const handleNext = () => {
    navigate(`/nomineeUpdate/${nextStage}`);
 
  };

  const GetNomineeModificationRequest = () => {
    const NomineeRequestID = sessionStorage.getItem("nomineeRequestID");

    let obj: any = {
      request_id: NomineeRequestID,
      update_component: "nominee",
      latitude: sessionStorage.getItem("latitude"),
      longitude: sessionStorage.getItem("longitude"),
    };
    SaveIpAddressAPICall(obj)
      .then((response: any) => {
        // console.log("response", response.data.data);

        navigate(`/nomineeUpdate/${nextStage}`);
      })
      .catch((error: any) => {
        seterrorMessage("latitude and longitude not found");
        setTimeout(() => {
          seterrorMessage("");
        }, 5000);
      });
  };

  return (
    <>
      <SucessSnackBar message={successMessage} />
      <SnackBar message={errorMessage} />
      <ErrorSnackBar message={rejectMessage} />
      <div className={BankStyles.mainWrapper}>
        <div className={BankStyles.wrapper}>
          <div className={BankStyles.step}>
            <img src={keyboardicon} /> Step 1 of 3
          </div>
          <div>
            <p className={BankStyles.Header}>Profile Details</p>
          </div>
          <p className={BankStyles.subText}>
            View your Profile information below for confirmation
          </p>
          <div className={BankStyles.txtwrapper}>
            <Grid
              container
              rowSpacing={5}
              columnSpacing={{ xs: 1, sm: 2, md: 5 }}
            >
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                  id="outlined-basic"
                  label="Client Code"
                  variant="outlined"
                  value={userData?.clientCode ? userData.clientCode : ""}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                  id="outlined-basic"
                  label="Full Name"
                  variant="outlined"
                  value={userData?.fullName ? userData.fullName : ""}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                  id="outlined-basic"
                  label="Email"
                  variant="outlined"
                  value={userData?.email ? userData.email : ""}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                  id="outlined-basic"
                  label="Mobile"
                  variant="outlined"
                  value={userData?.mobile ? userData.mobile : ""}
                />
              </Grid>
            </Grid>
          </div>
          <div className={BankStyles.buttonStack}>
            <LoadingButton
              loading={loading}
              variant="contained"
              type="submit"
              id="linkUsingIFSCContinueButton"
              className={BankStyles.approveButton}
              sx={{
                fontSize: "12px",

                padding: "8px 70px",
                height: "50px",
              }}
              onClick={handleNext}
            >
              Continue
            </LoadingButton>
          </div>
        </div>
      </div>
    </>
  );
}
